import { Component, forwardRef, Input } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Subject } from 'rxjs';
@Component({
  selector: 'duration-picker',
  template: `
    <div [formGroup]="parts" matTooltip="mm:ss:ms">
      <input
        formControlName="minutes"
        (input)="valueChanges()"
        (click)="$event.target.select()"
        size="2"
      />
      <span>:</span>
      <input
        formControlName="seconds"
        (input)="valueChanges()"
        (click)="$event.target.select()"
        size="2"
      />
      <span>:</span>
      <input
        formControlName="centiseconds"
        (input)="valueChanges()"
        (click)="$event.target.select()"
        size="2"
      />
    </div>
  `,
  styles: [
    `
      div {
        display: flex;
      }
      input {
        border: none;
        background-color: #303030;
        padding: 2px 2px 2px 2px;
        outline: none;
        font: inherit;
        text-align: center;
        color: white;
        width: 2em;
        margin: 0px 4px 0px 4px;
      }
      span{
        display: flex;
        align-items: center;
      }
      input[disabled=""]{
        border: none;
        background: none;
        margin: 0;
        padding: 0;
        width: 1.5em;
      }
    `
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DurationPickerComponent),
      multi: true
    }
  ]
})
export class DurationPickerComponent implements ControlValueAccessor {
  parts: FormGroup;
  stateChanges = new Subject<void>();
  @Input()
  get disabled(): boolean {
    return this._disabled;
  }
  set disabled(value: boolean) {
    this._disabled = coerceBooleanProperty(value);
    this._disabled ? this.parts.disable() : this.parts.enable();
    this.stateChanges.next();
  }
  private _disabled = false;
  valueChanges(): void {
    const n = this.parts.value;
    this.propagateChange(this.partsToSeconds(n));
  }
  propagateChange = (_: any) => {};

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(): void {}
  writeValue(value: number): void {
    const duration = this.secondsToParts(value);
    this.parts.setValue({
      minutes: duration.minutes,
      seconds: duration.seconds,
      centiseconds: duration.centiseconds
    });
  }
  secondsToParts(
    seconds: number
  ): { minutes: string; seconds: string; centiseconds: string } {
    const minutes = Math.floor(seconds / 60);
    const sec = seconds - minutes * 60;
    const centiseconds = Math.round((seconds % 1) * 100);
    let minutesString = minutes.toString();
    minutesString = minutes < 10 ? '0' + minutesString : minutesString;
    let secondsString = Math.floor(sec).toString();
    secondsString = sec < 10 ? '0' + secondsString : secondsString;
    let csString = centiseconds.toString();
    csString = centiseconds < 10 ? '0' + csString : csString;
    return {
      minutes: minutesString,
      seconds: secondsString,
      centiseconds: csString
    };
  }
  partsToSeconds(parts: {
    minutes: string;
    seconds: string;
    centiseconds: string;
  }): number {
    return (
      parseInt(parts.minutes, 10) * 60 +
      parseInt(parts.seconds, 10) +
      parseInt(parts.centiseconds, 10) / 100
    );
  }
  constructor(fb: FormBuilder) {
    this.parts = fb.group({
      minutes: '',
      seconds: '',
      centiseconds: ''
    });
  }
}
